import { ImageDtoType } from 'types/services/magnolia/dtos/ImageDto';
import { OptionalProgramItemsStateType, RootStateType } from '.';
import { initialState } from '../trackingDescription';

export const getState = (state: RootStateType): OptionalProgramItemsStateType => {
	return state.optionalProgramItems || initialState;
};

export const getTitle = (state: RootStateType, key: string): string | void => {
	const selectedState = getState(state);
	const selectedItem = selectedState.items[key];

	if (selectedItem) {
		return selectedItem.title;
	}
};

export const getText = (state: RootStateType, key: string): string | void => {
	const selectedState = getState(state);
	const selectedItem = selectedState.items[key];

	if (selectedItem) {
		return selectedItem.text;
	}
};

export const getPreviewImage = (state: RootStateType, key: string): ImageDtoType | void => {
	const selectedState = getState(state);
	const selectedItem = selectedState.items[key];

	if (selectedItem) {
		return selectedItem.previewImage;
	}
};
